hrd.form.openTableDialog = function(html, fnCreateTableCallback, options, extraSettings) {
	var deferred = $.Deferred();
	var $content = $(html).appendTo('body');
	var dialogId = '#' + $content.uniqueId().attr('id');
	this.showTableDialog(dialogId, fnCreateTableCallback, options, extraSettings)
		.then(function(obj, options) {
			deferred.resolve(obj, options);
		}).fail(function(options) {
			deferred.reject(options);
		}).always(function() {
			setTimeout(function() {
				$content.remove();
			}, 0);
		});
	return deferred.promise();
};

hrd.form.showTableDialog = function(dialogId, fnCreateTableCallback, options, extraSettings) {
	var deferred = $.Deferred();
	var $dialog = $(dialogId);
	var tableInstance = undefined;
	if (!$dialog.exists()) {
		hrd.dashboard.msgBox({
			title: 'Warning',
			text: 'Dialog Id does not exists: "' + dialogId + '"',
			type: 'OK'
		});
	}
	var defaults = {
		modal: true,
		resizable: false,
		closable: false,
		maximizable: false,
		minimizable: false,
		resizeOnDlbclick: false,
		position: { my: "center", at: "center", of: window }, // from jquery ui
		okLabel: xlate('common.dialog.ok.btn'),
		cancelLabel: xlate('common.dialog.cancel.btn'),
		width: 600,
		height: 'auto',
		doNotCloseOnOk: false,
		onOpen: $.noop,
		extraButtons: [],
		closeOnOverlay: false,
		fnCreateTableCallback: fnCreateTableCallback || $.noop,
		showOkButton: true,
		showCancelButton: true,
		disableOkButton: false,
		disableCancelButton: false,
		reference: undefined,// needed for faster implementations
		title: null, // it means: use the html defined one
		autoOpen: true,
		buttonWhenEmpty: 'cancel-button'
	};
	options = options || {};

	$dialog.addClass('table-dialog');

	if ($dialog.data('width')) {
		options.width = $dialog.data('width');
	}

	if ($dialog.data('height')) {
		options.height = $dialog.data('height');
	}

	if ($dialog.data('title') && !options.title) {
		options.title = $dialog.data('title');
	}

	if ($dialog.data('ok-label') && !options.okLabel) {
		options.okLabel = $dialog.data('ok-label');
	}

	if ($dialog.data('cancel-label') && !options.cancelLabel) {
		options.cancelLabel = $dialog.data('cancel-label');
	}
	var settings = $.extend({}, defaults, options);

	function onOpenPromise(tableInstance) {
		let openPromise = $.when();

		if (typeof settings.onOpen === 'function') {
			openPromise = $.when(settings.onOpen(tableInstance, dialogId));
		}

		return openPromise;
	}

	var tableImpl = undefined; //$dialog.data('tableImpl'); // needed when used with a 'AbstractTablePopup' object
	if ($dialog.data('popup') && tableImpl == undefined) {
		var dialogInfo = $.evaluate($dialog.data('popup'));
		$dialog.data('popupInfo', dialogInfo);
		var dOpt = {
			impl: dialogInfo.impl,
			prefix: dialogInfo.prefix,
			dialog: $dialog,
			extraSettings: extraSettings
		}
		if (dialogInfo.options) {
			dOpt = $.extend(dOpt, dialogInfo.options);
		}

		var $dialogContent = $('.dialog-content', $dialog);
		tableImpl = $.evaluate('new impl(panel, opts)', this, [$.evaluate(dialogInfo.impl), $dialogContent, dOpt], ['impl', 'panel', 'opts']);
		tableImpl.uuid = parseInt(Math.random() * 1000);
		//$dialog.data('tableImpl', tableImpl); // store for next use !!! not for now because too data caching

		// override onOpen if available in tableImpl
		if (tableImpl.settings.onOpen == undefined) {
			var onOpenFn = tableImpl['onOpen'];
			if (typeof onOpenFn === 'function') {
				settings.onOpen = onOpenFn.bind(tableImpl);
			}
		}
	}

	var dialogOpt = {
		isOk: function() {
			return this.buttonClicked !== undefined && this.buttonClicked.hasClass('ok-button');
		},
		isCancel: function() {
			return this.buttonClicked !== undefined && this.buttonClicked.hasClass('cancel-button');
		},
		is: function(action) {
			return this.buttonClicked !== undefined && this.buttonClicked.hasClass(action);
		}
	}

	var proceedAndResolveFn = function(event) {
		var $button = $(event.currentTarget);
		var isButtonDisabled = $button.button('option', 'disabled');
		if (!isButtonDisabled) {
			dialogOpt.buttonClicked = $button;
			var promise;
			var data;
			// old tables are 'multiselect' for backward compatibility. once removed all old tables, adapt this code accordingly
			var isMultiSelectTable = (tableImpl != undefined) ? tableImpl.manager.settings.isMultiSelectTable : true;
			var data = (isMultiSelectTable) ? tableInstance.fnGetData() : undefined;

			if (tableImpl && typeof tableImpl.onProceed == 'function') {
				promise = $.when(tableImpl.onProceed.call(tableImpl, data, dialogOpt));
			} else {
				promise = $.when();
			}

			promise.then(function(effectiveData) {
				effectiveData = (isMultiSelectTable) ? effectiveData || data : effectiveData;
				deferred.resolve(effectiveData, dialogOpt);
				if (!settings.doNotCloseOnOk) {
					$dialog.dialog('close');
				}
			});
		} else {
			event.stopPropagation();
			event.preventDefault();
		}
	};

	var buttons = [];
	if (settings.showOkButton) {
		buttons.push({
			'text': settings.okLabel,
			'class': 'ok-button',
			'click': proceedAndResolveFn,
			'disabled': settings.disableOkButton
		});
	}

	if (settings.showCancelButton) {
		buttons.push({
			'text': settings.cancelLabel,
			'class': 'cancel-button',
			'click': function(event) {
				$dialog.dialog('close');
			},
			'disabled': settings.disableCancelButton
		});
	}

	/* prepare extra buttons (extra buttons --> buttons near to ok/cancel */
	$.map(settings.extraButtons, function(extraButton) {
		extraButton.click = proceedAndResolveFn;
		return extraButton;
	});

	buttons = settings.extraButtons.concat(buttons);
	
	// adapt w & h to layout-size
	if((typeof settings.width === 'string' && !settings.width.includes('%') && settings.width != 'auto') || (typeof settings.width === 'number') ) {
		settings.width = dashboardInstance.adaptSize(settings.width);
	}

	if((typeof settings.height === 'string' && !settings.height.includes('%') && settings.height != 'auto') || (typeof settings.height === 'number') ) {
		settings.height = dashboardInstance.adaptSize(settings.height);
	}	

	if (typeof settings.width === 'string' && settings.width.includes('%')) {
		settings.width = parseInt(settings.width.replaceAll('%', ''));
		settings.width = $(window).width() * (settings.width / 100);
	}

	if (typeof settings.height === 'string' && settings.height.includes('%')) {
		settings.height = parseInt(settings.height.replaceAll('%', ''));
		settings.height = $(window).height() * (settings.height / 100);
	}

	$dialog.dialog({
		modal: settings.modal,
		position: settings.position,
		resizable: settings.resizable,
		closable: settings.closable,
		maximizable: settings.maximizable,
		minimizable: settings.minimizable,
		resizeOnDlbclick: settings.resizeOnDlbclick,
		autoOpen: settings.autoOpen,

		maximizeIcon: 'f-icon far fa-window-maximize',
		minimizeIcon: 'f-icon far fa-window-minimize',
		minimizeLocation: 'right',
		restoreIcon: 'f-icon far fa-window-restore',
		height: settings.height,
		width: settings.width,
		minHeight: 200,
		title: settings.title,
		buttons: buttons,

		create: function(event, ui) {
			/* used for 2x dialogs */
			if (dashboardInstance.isDoubleSize()) {
				$dialog.closest('.ui-dialog').addClass('dialog-2x');
			}
		},

		open: function(event, ui) {
			var dialogInfo = $dialog.data('popupInfo');
			if (dialogInfo != undefined) {
				if (tableInstance == undefined) {
					var $dialogContent = $('.dialog-content', $dialog);
					$dialogContent.waiting('opaque');
					$dialogContent.addClass('full-height'); // so that content dialog has full height and the table will have full height too

					tableImpl.doTable().then((instance) => {
						tableInstance = instance;
						if (typeof settings.onOpen === 'function') {
							settings.onOpen(tableInstance, dialogId);
						}
						$dialogContent.waiting('done');
						$('.ok-button', $dialog.closest('.ui-dialog')).focus();

						// repositioning to original position
						$dialog.dialog('option', 'position', $dialog.dialog('option', 'position'));
					});
				} else {
					// repositioning to original position
					$dialog.dialog('option', 'position', $dialog.dialog('option', 'position'));

					tableInstance.fnDraw();
				}
			} else {
				$.timeout(0).then(function() {
					$.when(settings.fnCreateTableCallback()).then((instance) => {
						tableInstance = instance;
						if (typeof settings.onOpen === 'function') {
							settings.onOpen(tableInstance, dialogId);
						}
						$('.ok-button', $dialog.closest('.ui-dialog')).focus();

						// repositioning to original position
						$dialog.dialog('option', 'position', $dialog.dialog('option', 'position'));
					});
				});
			}
			if (settings.closeOnOverlay) {
				$('.ui-widget-overlay').off('click.overlay').on('click.overlay', () => {
					$dialog.dialog('close');
				});
			}
		},

		beforeClose: function(event, ui) {
			// clear some initial data
			if (tableInstance != undefined) {
				if (tableImpl != undefined) {
					// clear preselected indexes
					tableImpl.selectedIndexes = [];
					tableImpl.clearSelectedIndexes();
					tableImpl.clearFilters(false);
					tableImpl.clearRowActive();
				}
				// clear tbody element and aoData array in settings in order to avoid 'previously popupated rows'
				$('tbody', tableInstance).empty();
				tableInstance.fnSettings().aoData = [];
			}
		},

		close: function(event, ui) {
			if (deferred.state() === 'pending') {
				deferred.reject();
			}
		}
	});

	if (settings.autoOpen === false) {
		if (tableImpl == undefined) {
			console.log('Cannot use "autoOpen = false" for dialogs without table implementation')
		} else {
			tableImpl.manager.testProvider().then(rows => {
				if (rows.iTotalRecords > 0) {
					$dialog.dialog('open')
				} else {
					var bwe = tableImpl.getButtonByAction(settings.buttonWhenEmpty);
					if (bwe.exists()) {
						tableImpl.executeButtonByAction(settings.buttonWhenEmpty)
					} else {
						console.log('The button "' + settings.buttonWhenEmpty + '" is not defined. Promise wil be rejected')
						deferred.reject();
					}
				}
			});
		}
	}

	return deferred.promise();
};
